import { render } from "./twelve-faq.vue?vue&type=template&id=678e568f"
import script from "./twelve-faq.vue?vue&type=script&lang=js"
export * from "./twelve-faq.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__